<template>
  <div
    @show-inactive-subscription="inactiveSubscriptionVisible = true"
  >
    <div
      class="programs admin user-programs"
      :class="[
        'page-' + $router.currentRoute.name,
        { fixed: $store.state.pageFixed },
      ]"
    >
      <a
      :inert="$store.state.showWelcome"
      href="#main"
      tabindex="0"
      @keyup.tab="setIncludeSkipToMain"
      class="skip-to-content">
        Skip to main content
      </a>
      <!-- TODO: these above should be dynamic? -->
      <cty-header-bar
        v-if="
          this.$store.getters.currentUser && this.$store.getters.currentEdition
        "
      ></cty-header-bar>
      <slot />
    </div>
    <cty-header-bar-popups></cty-header-bar-popups>

    <modal v-if="showFailedRenewal" @dismiss="closeFailedRenewal">
      <update-subscription-payment @dismiss="closeFailedRenewal" />
    </modal>
    <modal
      v-if="inactiveSubscriptionVisible"
      maxWidth="650px"
      @dismiss="closeInactiveSubscription"
    >
      <inactive-subscription
        @dismiss="closeInactiveSubscription"
      ></inactive-subscription>
    </modal>
  </div>
</template>

<style lang="less" scoped>
#nav {
  z-index: 100;
  position: relative;
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
  .header .nav-links a {
    padding-bottom: 4px;
  }
}
.programs.fixed {
  position: fixed;
  width: 100%;
}

.skip-to-content {
  padding: 6px;
  position: absolute;
  top: -40px;
  left: 0px;
  color: white;
  border-right: 1px solid white;
  border-bottom: 1px solid white;
  border-bottom-right-radius: 8px;
  background: #BF1722;
  -webkit-transition: top 1s ease-out;
  text-decoration: underline;
  transition: top 1s ease-out;
  z-index: 100;
  opacity: 1;
  &:focus {
    top: 0px;
    outline-color: transparent;
    -webkit-transition: top .1s ease-in;
    transition: top .1s ease-in;
  }
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import CtyHeaderBar from "@/common/components/HeaderBar";
import CtyHeaderBarPopups from "@/common/components/HeaderBarPopups";
import Modal from "@/common/components/Modal";
import UpdateSubscriptionPayment from "@/settings/UpdateSubscriptionPayment";
import InactiveSubscription from "@/settings/InactiveSubscription";

export default {
  data: function() {
    return {
      journeysOpenApplied: false,
      timeout: null,
      failedRenewalDismissed: false,
      inactiveSubscriptionDismissed: false,
      forceInactiveSubscription: false,
    };
  },
  components: {
    CtyHeaderBarPopups,
    CtyHeaderBar,
    Modal,
    UpdateSubscriptionPayment,
    InactiveSubscription,
  },
  computed: {
    showFailedRenewal() {
      return (
        this.currentUser &&
        this.currentUser.failed_renewal &&
        !this.failedRenewalDismissed &&
        this.$route.name !== "billing_settings" &&
        !this.currentUser.inactive_subscription
      );
    },
    inactiveSubscriptionVisible() {
      return (
        this.currentUser &&
        this.$store.getters.currentUser.inactive_subscription &&
        (this.forceInactiveSubscription ||
          (this.$route.name !== "billing_settings" &&
            !this.inactiveSubscriptionDismissed))
      );
    },
    ...mapState({
      triggerInactiveSubscriptionModal: (state) =>
        state.payment.triggerInactiveSubscriptionModal
    }),
    ...mapGetters(["currentUser"]),
  },
  watch: {
    triggerInactiveSubscriptionModal(show) {
      if (show) {
        this.forceInactiveSubscription = true;
        this.inactiveSubscriptionDismissed = false;
      }
    }

  },
  methods: {
    closeFailedRenewal() {
      this.failedRenewalDismissed = true;
    },
    closeInactiveSubscription() {
      this.$store.commit("setTriggerInactiveSubscriptionModal", false);
      this.inactiveSubscriptionDismissed = true;
      this.forceInactiveSubscription = false;
    },
  },
};
</script>
